import React from 'react';
import styled from '@emotion/styled';

export const Root = styled.div`
  font-family: Ubuntu;
  line-height: 1.6;
  margin: 0px auto;
  max-width: 1440px;
  padding: 0px 10px;

  .gradientBackground {
    background-image: url('/map-images/bluefade.svg');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    border: 1px solid red;
  }
  img {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;

export const Section = styled.section`
  padding: 40px 16px;
  position: relative;
  margin: 0 auto;
  max-width: calc(100vw - 40px);
  border: 1px solid blue;
  img {
    margin: 48px auto 0;
    display: block;
  }
  .blueHeader.blueHeader {
    color: #0318C6;
    text-align: center;
    font-family: Syne;
    font-size: 34px;
    line-height: 40px;
  }
  .blueSubHeader {
    color: #0318C6;
    text-align: center;
    font-family: Syne;
    font-size: 18px;
    line-height: 24px;
    margin-top: 16px;
    text-wrap: balance;
  }
  .nameAndTitle {
    color: #000;
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    text-align: center;
    margin-top: 16px;
    p:first-of-type {
      font-weight: 700;
    }
  }
  .mobile-text {
    color: #000;
    font-family: Ubuntu;
    font-size: 15px;
    font-weight: 500;
    line-height: 25px;
    margin-top: 32px;
    .readMore {
      font-weight: 300;
      text-decoration: underline;
      color: #0318C6;
      display: inline-block;
      padding-left: 4px;
    }
    p:last-of-type {
      font-weight: 300;
      margin-top: 16px;
    }
  }
  .sectionText {
    font-weight: 500;
    line-height: 28px;
    font-size: 18px;
    font-family: Ubuntu, sans-serif;
    display: none;
    p:last-of-type {
      margin-top: 32px;
      font-weight: 300;
    }
  }
`;

export const MissionSection = styled(Section)` 
  position: relative;
    z-index: 4;
    * {
      position: relative;
      z-index: 4;
    }
    .mobile-circles {
      position: absolute;
      top: 0;
      right: -20px;
      z-index: 1;
    }
`;
export const HildeshaimSection = styled(Section)` 
`;
export const ExpertiseSection = styled(Section)`
  padding-top: 32px;
  .three-plus {
    position: absolute;
    left: -21px;
    top: -50px;
  }
`;
export const TechnologySection = styled(Section)` 
`;
export const TeamSection = styled(Section)`
  padding-top: 32px;
  .five-plus {
    position: absolute;
    right: -0px;
    top: -50px;
  }
  .side-motif {
    /* position: absolute;
    right: 0;
    bottom: 0; */
    border: 1px solid red;
  }
`;
export const RelationshipsSection = styled(Section)`
  overflow: visible;
  padding-top: 40px;
  * {
    position: relative;
    z-index: 2;
  }
  .targetsites {
    position: absolute;
    left: -22px;
    width: calc(100% + 44px);
    top: 10px;
    z-index: 1;
  }
`;
export const CPASection = styled(Section)`
  h2 {
    position: relative;
    display: inline-flex;
  }
  .single-one {
    position: absolute;
    left: -100px;
    top: -40px;
    z-index: 4;
  }
  .single-two {
    position: absolute;
    left: -140px;
    top: -8px;
    z-index: 4;
  }
  .single-three {
    position: absolute;
    right: -130px;
    top: 8px;
    z-index: 4;
  }
`;
export const OurClientsSection = styled(Section)`
  overflow: hidden;
  .darth-fader {
    width: 100%;
    height: auto;
    position: absolute;
    top: 0;
    left: 0;
  }
  .sectionText {
    display: block;
    font-size: 15px;
    font-weight: 300;
    line-height: 25px;
    text-align: center;
    margin-top: 48px;
  }
  .three-plus {
    position: absolute;
    right: 10px;
    top: -50px;
    z-index: 4;
  }
  .single-one {
    position: absolute;
    left: -36px;
    bottom: 86px;
    z-index: 4;
  }
  .single-two {
    position: absolute;
    left: -10px;
    bottom: 48px;
    z-index: 4;
  }
  .single-three {
    position: absolute;
    right: 0px;
    bottom: 30px;
    z-index: 4;
  }
  .sectionText {
    display: block;
  }
`;

export function ThingIcon({ ...props }) {
  return (
    <svg
      width='15'
      height='36'
      viewBox='0 0 15 36'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
      style={{ display: 'block', margin: '16px auto 0' }}
    >
      <path d='M7.5 0L7.5 36' stroke='#9C9C9C' stroke-width='0.5' />
      <circle cx='7.5' cy='29' r='7' fill='#7894AE' />
    </svg>
  );
}
